import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const NotFound = () =>
{
  const { isAuthenticated } = useSelector(state => state.auth);
  const { t } = useTranslation();
  //TODO: Login olmayan bir kullanıcı not found yerine login sayfasına atılmalı
  // if (!isAuthenticated) return <Navigate to="/login" />
  return (
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
      >
        <Typography variant="h1">{t("404")}</Typography>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">{t("not_found")}</Typography>
        </div>
        <div style={{ padding: "1rem" }}>
          <Button variant="contained" color="primary" component={Link} to="/">
            {t("return_home")}
          </Button>
        </div>
      </Box>
    </Container>
  );
};

export default NotFound;
